import { render } from "./poolDetail.vue?vue&type=template&id=36a208b7&scoped=true&ts=true"
import script from "./poolDetail.vue?vue&type=script&lang=ts"
export * from "./poolDetail.vue?vue&type=script&lang=ts"

import "./poolDetail.vue?vue&type=style&index=0&id=36a208b7&scoped=true&lang=less"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a208b7"]])

export default __exports__